// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function customer_auth_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var auth_token = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "auth_token"), null));
  if (auth_token.TAG === /* Ok */0) {
    var mobile = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mobile"), null));
    if (mobile.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                auth_token: auth_token._0,
                mobile: mobile._0
              }
            };
    }
    var e = mobile._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".mobile" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = auth_token._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".auth_token" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var customer = customer_auth_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "customer"), null));
  if (customer.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              customer: customer._0
            }
          };
  }
  var e = customer._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".customer" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  customer_auth_info_decode ,
  t_decode ,
}
/* No side effect */
